import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import ImageUploader from "./components/ImageUploader";
import AppUpperSection from "./components/AppUpperSection";
import AppLowerSection from "./components/AppLowerSection";
import LanguageSwitcher from "./components/LanguageSwitcher";
import "./App.css";
import "./i18n"; // Import i18n configuration

function App() {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (process.env.NODE_ENV === "production") {
      // Google Analytics Script
      const gtagScript = document.createElement("script");
      gtagScript.async = true;
      gtagScript.src =
        "https://www.googletagmanager.com/gtag/js?id=G-ZHJP7PJ5MD";
      document.head.appendChild(gtagScript);

      // Google Tag Manager & UET Consent
      const scriptContent = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){ dataLayer.push(arguments); }

        gtag('consent', 'default', {
            'ad_storage': 'denied',
            'ad_user_data': 'denied',
            'ad_personalization': 'denied',
            'analytics_storage': 'denied'
        });

        gtag('set', 'url_passthrough', true);
        gtag('set', 'ads_data_redaction', true);

        gtag('js', new Date());
        gtag('config', 'G-ZHJP7PJ5MD');

        // UET Consent Settings (Microsoft Advertising)
        window.uetq = window.uetq || [];
        window.uetq.push('consent', 'default', {
            'ad_storage': 'denied'
        });
      `;

      const inlineScript = document.createElement("script");
      inlineScript.innerHTML = scriptContent;
      document.head.appendChild(inlineScript);
    } else {
      const meta = document.createElement("meta");
      meta.name = "robots";
      meta.content = "noindex, nofollow";
      document.head.appendChild(meta);
    }
  }, []);

  // Handle URL-based language detection
  useEffect(() => {
    const handleUrlChange = () => {
      const path = window.location.pathname;
      const pathMatch = path.match(/\/total\/([a-z]{2})\/image-translator/);
      if (pathMatch && pathMatch[1]) {
        const detectedLang = pathMatch[1];
        const supportedLanguages = ['en', 'fr', 'it', 'es', 'ar', 'zh', 'de', 'ja', 'ru', 'uk'];
        if (supportedLanguages.includes(detectedLang) && i18n.language !== detectedLang) {
          i18n.changeLanguage(detectedLang);
        }
      }
    };

    // Listen for popstate events (back/forward navigation)
    window.addEventListener('popstate', handleUrlChange);
    
    // Initial check
    handleUrlChange();

    return () => {
      window.removeEventListener('popstate', handleUrlChange);
    };
  }, [i18n]);

  // Change Browser Tab Title
  useEffect(() => {
    document.title = t("app.header.title"); // Set the custom tab title
  }, [t, i18n.language]); // Re-run when language changes

  return (
    <div className="app-container">
      <LanguageSwitcher />
      <AppUpperSection />

      <div className="content">
        <ImageUploader />
      </div>

      <AppLowerSection />
    </div>
  );
}

export default App;
